module.exports = __webpack_public_path__ + "img/aws.6bb0fcd0.png";